import { useContext } from "react"
import { useLocation } from "react-router-dom"
import "source/giving/donation_form/styles/donation-form-doxy-overrides.css"
import { NarrowLayout } from "source/Layout"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"
import { PostDonateStatus } from "../donation_form/components/PostDonateStatus"
import { PostDonateSuccessLinks } from "../donation_form/components/PostDonateSuccessLinks"
import { dateStampStringToLocal } from "../donation_form/utils/frequency"

export function DonationThankYou() {
  const {
    current_person: {
      data: {
        attributes: { first_name, email_address, address },
      },
    },
    current_organization: { contact_website },
  } = useContext(ServerRenderedProps)

  const {
    state: { date, recurring },
  } = useLocation()

  const message = recurring
    ? `Your recurring donation is scheduled ${date ? "to begin on " + dateStampStringToLocal(date) : ""}.`
    : `Your donation has been received, and a receipt was sent to ${email_address}.`

  return (
    <NarrowLayout>
      <PostDonateStatus
        status="success"
        heading={`Thank you, ${first_name}!`}
        message={message}
        actions={
          <PostDonateSuccessLinks
            donorAddress={address}
            orgWebsite={contact_website}
          />
        }
      />
    </NarrowLayout>
  )
}
